import {  useState } from "react";
import { IconThreeDots } from "antopolis-react-icons";
import { useGetInfo } from "antopolis-react-utils/hooks";

import { useUseOrientation } from "../../../../Utilities/Hooks/useUseOrientation";
import { useAxiosInstance } from "../../../../Utilities/Hooks/useAxiosInstance";
import { CreateButton } from "../../../Partials/Layout/CRUD/CreateButton/CreateButton";
import { CRUDTable } from "../../../Partials/Layout/CRUD/CRUDTable/CRUDTable";
import { CRUDTableHeader } from "../../../Partials/Layout/CRUD/CRUDTableHeader/CRUDTableHeader";
import { CRUDth } from "../../../Partials/Layout/CRUD/CRUDth/CRUDth";
import { ImageCell } from "../../../Partials/Layout/CRUD/ImageCell/ImageCell";
import { EditButton, ViewButton } from "../../../Partials/Layout/CRUD/CRUDButtons/CRUDButtons";
import { Modal } from "../../../Partials/Elements/Modal/Modal";
import CreateClient from "./CreateClient";
import ViewClient from "./ViewClient";
import UpdateClient from "./UpdateClient";


function Clients({  api }) {

  const [showActionButton, setShowActionButton] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);
  const [toggleFetch, setToggleFetch] = useState(false);

  const [targetID, setTargetID] = useState(null);

  const { portrait } = useUseOrientation();
  const axiosInstance = useAxiosInstance();
// fetch services
// fetch services
// fetch services
// fetch services
  const { info: clients } = useGetInfo({
    axiosInstance: axiosInstance,
    api:api,
    toggleFetch
  });

  function triggerFetch() {
    setToggleFetch((prevState) => !prevState);
  }

  return (
    <div className="screen_wrapper">
      <div className="screen_header" >
        <h1 className="screen_heading">
          Clients ({clients?.length} in total)
        </h1>
        <CreateButton
          screenTopicSingular={"Client"}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable >
        <CRUDTableHeader>
          <CRUDth th="Image" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>
        <tbody>
          {clients?.map((client) => (
            <tr key={client._id}>
              <ImageCell imgSrc={client.image} />
              <td>
                <div className="action_buttons_wrapper">
                  <button
                    className="three_dots"
                    onClick={() => {
                      setShowActionButton(true);
                      setTargetID(client._id);
                    }}
                  >
                    <IconThreeDots />
                  </button>
                  {!portrait && (
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={client._id}
                        setTargetID={setTargetID}
                      />
                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={client._id}
                        setTargetID={setTargetID}
                      />
                    </div>
                  )}
                  {portrait && showActionButton && targetID === client._id && (
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={client._id}
                        setTargetID={setTargetID}
                      />
                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={client._id}
                        setTargetID={setTargetID}
                        setShowActionButton={setShowActionButton}
                      />
                    </div>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>

      </CRUDTable>

      {showCreateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Create client`}
          setShowModalContent={setShowCreateForm}
        >
          
          <CreateClient
            setShowCreateForm={setShowCreateForm}
            triggerFetch={triggerFetch}
            api={api}
          />
        </Modal>
      )}
      {showUpdateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Update client`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateClient
            setShowUpdateForm={setShowUpdateForm}
            targetID={targetID}
            triggerFetch={triggerFetch}
            api={api}
          />
        </Modal>
      )}

      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={`View client`}
          setShowModalContent={setShowViewSection}
        >
          <ViewClient targetID={targetID} api={api} />
        </Modal>
      )}

    </div>
  );
}

export default Clients;
